<template>
  <v-tooltip top color="primary">
    <template v-slot:activator="{ on }">
      <span v-on="on" class="subheading text-uppercase font-weight-black primary--text font-italic">{{ $t("screener.reserved.title") }}</span>
      <!-- <v-chip v-on="on" small color="success" text-color="white">
        <v-avatar>
          <v-icon>check_circle</v-icon>
        </v-avatar>
        {{ $t("screener.reserved.title") }}
      </v-chip> -->
    </template>
    <span class="background--text body-1">{{
      $t("screener.reserved.tooltip")
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ReservedIndicator"
};
</script>

<style>
</style>
